import React from 'react';

export function LoadingModal({ message }) {
  return (
    <div className="modal-overlay">
      <div className="loading-modal">
        <div className="loading-spinner"></div>
        <p className="loading-message">{message}</p>
      </div>
    </div>
  );
} 